import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import Stack from "@mui/joy/Stack";
import Grid from "@mui/joy/Grid";
import Link from './Link';
import Typography from "@mui/joy/Typography";
// import Card from "@mui/joy/Card";
// import CardContent from "@mui/joy/CardContent";
// import CardActions from "@mui/joy/CardActions";
// import Button from "@mui/joy/Button";
import { Identity } from '../stores/identity_store';
import { VerifiedIdentityForm } from './IdentityForm';
// import { RootStoreContext } from 'stores/root_store';

import useUserIdentity from 'hooks/useUserIdentity';
import { Success, Error } from './FancyToast';

import IdentityAvatar from './IdentityAvatar';

import useAuth from 'hooks/useAuth';


const IdentitiesSide = () => {
    const { identities } = useUserIdentity();
    const { currentUser } = useAuth();
    if(currentUser.allowed_identities <= 1) {
        return null;
    }

    return (
        <Stack m={3} spacing={1} >
            <Typography>
                Your account is allowed <Typography variant="soft">{currentUser.allowed_identities} identities</Typography>.
            </Typography>
            <Typography level="body-sm">
                These are you
            </Typography>
            { identities.map((i) =>
                <Link to={`/identity/${i.key}`}>
                    <IdentityAvatar  interactive={false} identityKey={i.key} size="inline" />
                </Link>
            ) }
        </Stack>
    );
}

const IdentityEditor = observer(() => {

    //    const [selectedIdentity, setIdentity] = useState({} as Identity);
    const {
        currentIdentity,
        createIdentity,
        updateIdentity,
        isYou,
        verifiedIdentity,
        setVerifiedIdentity,
         } = useUserIdentity();
    const { currentUser } = useAuth();
    const [checkingPermission, setCheckingPermission] = useState(true);
    const navigate = useNavigate();
    // const showClientIdentitiesCard =
    //     (currentUser.allowed_identities > identities.length) && verifiedIdentity?.key ;

    // const [stateVerifiedIdentity, setStateVerifiedIdentity] =
    //     useState({'verified': 'requested',
    //         'key': 'create-me',
    //     } as Identity);

    useEffect(() => {
        if(currentIdentity.key) {
            if(isYou(currentIdentity.key)) {
                setCheckingPermission(false);
            }
            else {
                navigate("/account");
            }
        }
    }, [currentIdentity.key]);


    function onSaveClick(identity: Identity) {
        console.log("onSaveClick identity:", identity);

        if (identity.key === 'create-me' || identity.key === undefined) {
            createIdentity(identity)
				.then((id) => {
                    if(id === undefined) {
                        Error("We had trouble saving this.")
                        return;
                    }
                    if(setVerifiedIdentity) {
                        setVerifiedIdentity(id);
                    }
                    navigate("/");
                    Success("Great! Saved.")
				})
                .catch((error) => {
                    console.error(error);
                    Error("We had trouble saving this.")
                });
        } else {
            console.log("TRYING TO UPDATE: %o", identity);
            updateIdentity(identity)
                .then((id) =>{
                    if(id === undefined) {
                        Error("Had trouble updating.")
                        return;
                    }
                    console.log("setVerifiedIdentity is %o", setVerifiedIdentity);
                    if(setVerifiedIdentity) {
                        setVerifiedIdentity(id);
                        Success("Updated!")
                    }
                    else {
                        Error("I had trouble updating.")
                    }
                    // navigate('/');
                })
                .catch((err) => {
                    console.error(err);
                    Error("I had trouble saving this");
                });


        }
    }

    return (
        <Grid container>

            <Grid xs={12} sm={8} >

                <Stack m={1}>
                { !verifiedIdentity?.key &&
                    <Stack m={3} spacing={1} >
                        <Typography level="title-md">
                            Welcome to Day Ones!
                        </Typography>
                    </Stack>
                }

                { checkingPermission  &&
                    <Stack alignItems="center">
                        <Typography level="title-lg">
                            Checking permission, just a sec.
                        </Typography>
                    </Stack>
                }

                    {!checkingPermission &&
                        <Stack spacing={1} >

                            <Stack>
                                <Typography level="title-lg">
                                    Let's set up your identity
                                </Typography>
                                <Stack>
                                    <Typography level="body-md">
                                        Your assistants will be able to see this information
                                    </Typography>
                                    <Typography level="body-xs">
                                        This is only revealed when they are clocked in on your requests
                                    </Typography>
                                </Stack>

                            </Stack>

                        <VerifiedIdentityForm
                            onSaveClick={onSaveClick}
                        />

                        {/* showClientIdentitiesCard &&
                        <ClientIdentitiesCard  /> */}
                    </Stack>
                }
                </Stack>
            </Grid>

            <Grid xs={12} sm={4} >
                { currentUser.allowed_identities > 1 &&
                    <IdentitiesSide /> }
            </Grid>

        </Grid>
    )
});

export default IdentityEditor;
